// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import {
    MutationChangeContract2DiagnosesicherheitArgs,
    MutationCreateContract2DiagnosesicherheitArgs, MutationDeleteContract2DiagnosesicherheitArgs,
} from '../../../mdqx-graphql-types';
import { Contract2DiagnosesicherheitEntity } from '../../../entities/mdqx/contract2diagnosesicherheit.entity';


export enum Contract2DiagnosesicherheitActionTypes {
    GetContract2DiagnosesicherheitenRequest = '[Contract2Diagnosesicherheiten] Get Request',
    GetContract2DiagnosesicherheitenResponse = '[Contract2Diagnosesicherheiten] Get Response',
    PostContract2DiagnosesicherheitRequest = '[Contract2Diagnosesicherheit] Post Request',
    PostContract2DiagnosesicherheitResponse = '[Contract2Diagnosesicherheit] Post Response',
    PatchContract2DiagnosesicherheitRequest = '[Contract2Diagnosesicherheit] Patch Request',
    PatchContract2DiagnosesicherheitResponse = '[Contract2Diagnosesicherheit] Patch Response',
    DeleteContract2DiagnosesicherheitRequest = '[Contract2Diagnosesicherheit] Delete Request',
    DeleteContract2DiagnosesicherheitResponse = '[Contract2Diagnosesicherheit] Delete Response',
}

export class GetContract2DiagnosesicherheitenRequest implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.GetContract2DiagnosesicherheitenRequest;
}

export class GetContract2DiagnosesicherheitenResponse implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.GetContract2DiagnosesicherheitenResponse;
    constructor(public Payload: Contract2DiagnosesicherheitEntity[]) {}
}

export class PostContract2DiagnosesicherheitRequest implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.PostContract2DiagnosesicherheitRequest;
    constructor(public Payload: MutationCreateContract2DiagnosesicherheitArgs) {}
}

export class PostContract2DiagnosesicherheitResponse implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.PostContract2DiagnosesicherheitResponse;
    constructor(public Payload: Contract2DiagnosesicherheitEntity) {}
}

export class PatchContract2DiagnosesicherheitRequest implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.PatchContract2DiagnosesicherheitRequest;
    constructor(public Payload: MutationChangeContract2DiagnosesicherheitArgs) {}
}

export class PatchContract2DiagnosesicherheitResponse implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.PatchContract2DiagnosesicherheitResponse;
    constructor(public Payload: Contract2DiagnosesicherheitEntity) {}
}

export class DeleteContract2DiagnosesicherheitRequest implements Action {
    readonly type = Contract2DiagnosesicherheitActionTypes.DeleteContract2DiagnosesicherheitRequest;
    constructor(public Payload: MutationDeleteContract2DiagnosesicherheitArgs) {}
}

export class DeleteContract2DiagnosesicherheitResponse implements Action {
    readonly type =
        Contract2DiagnosesicherheitActionTypes.DeleteContract2DiagnosesicherheitResponse;
    constructor(public Payload: number) {}
}

export type Contract2DiagnosesicherheitActions =
    | GetContract2DiagnosesicherheitenRequest
    | GetContract2DiagnosesicherheitenResponse
    | PostContract2DiagnosesicherheitRequest
    | PostContract2DiagnosesicherheitResponse
    | PatchContract2DiagnosesicherheitRequest
    | PatchContract2DiagnosesicherheitResponse
    | DeleteContract2DiagnosesicherheitRequest
    | DeleteContract2DiagnosesicherheitResponse;
